import { ActionIcon, Group, useMantineColorScheme } from "@mantine/core";
import { useHotkeys } from "@mantine/hooks";
import { IconMoonFilled, IconSunFilled } from "@tabler/icons-react";

const ThemeToggle = () => {
	const { colorScheme, toggleColorScheme } = useMantineColorScheme();

	useHotkeys([['mod+J', () => toggleColorScheme()]]);
	
	return <>
		<Group>
			{/* <Button variant="light" size="compact-md" radius="md">
				<Group gap={4}>
					<IconAdjustments size="16" />
					<Text inherit fz="xs">Display</Text>
					<IconChevronDown size="16" />
				</Group>
			</Button> */}
			<ActionIcon variant="light" radius="xl" onClick={() => toggleColorScheme()}>
				{colorScheme === 'light' ? <IconMoonFilled size={15} /> : <IconSunFilled size={15} />}
			</ActionIcon>
			{/* <ActionIcon variant="light" radius="xl">
				<IconCirclePlus size={26} strokeWidth={1} />
			</ActionIcon> */}
		</Group>
	</>
}

export default ThemeToggle